<template>
  <div class="text-left">
    <b-form @submit="onSubmit">
      <b-form-group label="Email" label-for="email">
        <b-form-input id="email" v-model="email" size="sm" required></b-form-input>
      </b-form-group>

      <b-form-group label="Senha" label-for="senha">
        <b-form-input id="senha" type="password" size="sm" v-model="senha" placeholder="Sua senha" required></b-form-input>
        <div class="help-block text-right"><router-link to="/recuperacao-de-senha">Esqueceu sua senha?</router-link></div>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button v-if="!trabalhando" type="submit" variant="secondary">Entrar</b-button>
        <b-button v-else variant="primary" disabled>
          <b-spinner small></b-spinner>
          Trabalhando...
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError, userKey } from '@/global'

export default {
  name: 'Login',
  data () {
    return {
      trabalhando: false,
      email: '',
      senha: ''
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      const acesso = {
        email: this.email,
        senha: this.senha
      }
      axios.post(`${baseApiUrl}/login`, acesso)
        .then(res => {
          // console.log('recuperou dados')
          this.$store.commit('setUser', res.data)
          // console.log('efetuou o commit do user')
          localStorage.setItem(userKey, JSON.stringify(res.data))
          // console.log('salvou no localstorage')
          this.$router.push({ path: '/area-do-participante/home' })
        })
        .catch(showError)
    }
  }
}
</script>

<style>

</style>
